
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M6.344 12.136c-.216 0-.336.216-.264.408A2.088 2.088 0 008 13.792c.864 0 1.608-.504 1.944-1.248.072-.192-.048-.408-.264-.408H6.344zM8.024 11.608l-4.776-.024a1.26 1.26 0 01-1.152-.768c-.192-.48-.096-.984.264-1.344C3.824 7.96 3.848 6.904 3.872 5.44c0-.624.024-1.32.144-2.136V3.28A3.662 3.662 0 017.64.184h.744c1.8 0 3.336 1.296 3.624 3.096v.024c.144.792.144 1.512.144 2.136.024 1.464.024 2.52 1.512 4.032.36.36.456.888.264 1.344a1.26 1.26 0 01-1.152.768l-4.752.024zM7.64 1.288a2.601 2.601 0 00-2.568 2.184v.024c-.12.72-.12 1.344-.144 1.968C4.904 7 4.88 8.44 3.104 10.24c-.072.072-.048.144-.024.192.024.048.048.096.168.096l4.776.024 4.776-.024c.096 0 .144-.072.168-.096.024-.048.024-.12-.024-.192-1.8-1.8-1.8-3.24-1.824-4.752 0-.624-.024-1.248-.144-1.968v-.024C10.76 2.224 9.68 1.288 8.408 1.312l-.768-.024z","fill":"#9BB0BE","fill-rule":"nonzero"}}),_c('path',{attrs:{"stroke":"#9BB0BE","stroke-linecap":"round","d":"M14 2.2L.8 8.2"}})])])
          )
        }
      }
    